import { render } from "./create-ticket.vue?vue&type=template&id=68ae835c&scoped=true"
import script from "./create-ticket.vue?vue&type=script&lang=js"
export * from "./create-ticket.vue?vue&type=script&lang=js"

import "./create-ticket.vue?vue&type=style&index=0&id=68ae835c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ae835c"]])

export default __exports__